<script setup lang="ts">
import type { BankAccount } from "@/api/bankAccount/types";
import { Finanzmanager } from '@/application/router/types/types';
import FaIcon from '@/application/components/ui/FaIcon.vue';
import CardMeta from '@/contracts/components/CardMeta.vue';
import { computed } from "vue";

interface Props {
  account: BankAccount,
}

const props = defineProps<Props>();

const contractsMetaLabel = computed(() => props.account.contractIds.length > 1
  ? `Hinterlegt bei ${props.account.contractIds.length} Verträgen`
  : 'Hinterlegt bei einem Vertrag');
</script>

<template>
  <RouterLink
    v-slot="{ navigate }"
    custom
    :to="{ name: Finanzmanager.BANK_ACCOUNT_DETAILS, params: { accountId: account.id } }"
  >
    <div
      class="relative cursor-pointer flex flex-col border border-gray-200 rounded-lg px-3 py-3 hover:shadow-md"
      @click="navigate"
    >
      <span
        v-if="account.main"
        class="absolute -top-3 -right-2 inline-block rounded-full bg-secondary px-[0.6em] py-[0.25em] text-[75%] font-bold leading-none text-center text-white align-baseline whitespace-nowrap"
      >
        Standard-Bankverbindung
      </span>

      <div class="flex flex-col justify-between">
        <span
          v-if="account.note.length > 0"
          class="font-medium text-base text-gray-900 mb-2"
        >
          {{ account.note }}
        </span>
        <span class="text-sm text-gray-700">
          {{ account.iban }}
        </span>
        <span class="text-sm text-gray-700">
          {{ account.bankName }}
        </span>
      </div>
      <CardMeta
        v-if="account.contractIds.length > 0"
        class="py-1.5"
      >
        <div
          class="flex flex-row items-center gap-2 ml-auto"
          :title="contractsMetaLabel"
        >
          <span class="text-xs">{{ contractsMetaLabel }}</span>
          <FaIcon
            name="file-contract"
            variant="light"
            size="lg"
          />
        </div>
      </CardMeta>
    </div>
  </RouterLink>
</template>
